module.exports = __webpack_public_path__ + "static/media/test_pic_1_thumb.de0ed938.jpg";